import { Themes } from '@brandandcelebrities/activities-themes';
const themes = new Themes();

export default themes.locale('fr-FR').sort().get();
